import { system } from '../../../node_modules/styled-system';

const textTransform = system({
    textTransform: true
});

export default textTransform;
